var cov_9uz00wkcv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/styles/index.ts",
      hash = "5b1919683b0ce10730f1047e7a275a5b2c82a5cf",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var datepickerLess = {};
import genaration from '../../utils/classname';
export var datepickerClass = (cov_9uz00wkcv.s[0]++, genaration(datepickerLess, 'datepicker'));